import React, { useEffect } from 'react';
import { assetUrl } from './scenario-api';
import styles from './scenario-studio.module.css';

interface AssetReplaceModalProps {
  scenarioId: string;
  assetPath: string;
  previewUrl: string;
  fileName: string;
  confirming: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AssetReplaceModal: React.FC<AssetReplaceModalProps> = ({
  scenarioId,
  assetPath,
  previewUrl,
  fileName,
  confirming,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !confirming) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel, confirming]);

  return (
    <div className={styles.modalOverlay} onClick={confirming ? undefined : onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <header className={styles.modalHeader}>
          <h3>Remplacer l&apos;image</h3>
          <button
            type="button"
            className={styles.iconBtn}
            onClick={onCancel}
            disabled={confirming}
          >
            ×
          </button>
        </header>
        <div className={styles.modalBody}>
          <p className={styles.hint} style={{ marginBottom: '1rem' }}>
            Le fichier sera enregistré sous <strong>{assetPath}</strong> (nom conservé).
            <br />
            Nouveau fichier : {fileName}
          </p>
          <div className={styles.assetCompare}>
            <div className={styles.assetCompareCol}>
              <h4>Avant</h4>
              <img
                className={styles.assetCompareImg}
                src={assetUrl(scenarioId, assetPath)}
                alt="Image actuelle"
              />
            </div>
            <div className={styles.assetCompareCol}>
              <h4>Après</h4>
              <img className={styles.assetCompareImg} src={previewUrl} alt="Nouvelle image" />
            </div>
          </div>
        </div>
        <footer className={styles.modalFooter}>
          <button
            type="button"
            className={styles.btnSecondary}
            onClick={onCancel}
            disabled={confirming}
          >
            Annuler
          </button>
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? (
              <>
                <span className={styles.spinner} /> Remplacement…
              </>
            ) : (
              'Confirmer le remplacement'
            )}
          </button>
        </footer>
      </div>
    </div>
  );
};
